// Donation step trigger
// The donation step trigger is used in the donation form's mobile view
// and desktop sidebar. On mobile they act more like accordions
// while on desktop it appears more as a static sidebar. By default
// only the first step is active. When each step is filled out and
// determined to be valid then the next step becomes available
// for interaction. This allows the user to navigate forward and
// backward through current and previous steps.
// ----------------------------------------------------------------

import $ from 'jquery';
import { focusFirstFieldsetInput } from '../focus-first-fieldset-input';
// import { inputValidationOnClick } from './input-validation-on-click';
// import { validationContinue } from './validation-continue';

const stepTrigger = $('.js-formStepTrigger');

$(stepTrigger).not('[data-donation-form-step="1"]').prop('disabled', true);

$(stepTrigger).on('click', function() {

    // Possible if needing to valid between navigation between steps

    // var fieldset = $(this).closest('.js-donationForm').find('fieldset:visible');

    // inputValidationOnClick(fieldset);
    // var stepValid = validationContinue(fieldset);

    // if (stepValid === true) {

        // Hides all fieldsets that are part of the donation form.
        $(this).closest('.js-donationForm').find('fieldset[data-donation-form-step]').hide();

        // Gets step value from clicked button.
        var step = parseInt($(this).attr('data-donation-form-step'));

        // Shows fieldset that matches step value from clicked button.
        $(this).closest('.js-donationForm').find('fieldset[data-donation-form-step="' + step + '"]').show();

        // Focus first input of step.
        focusFirstFieldsetInput(step);

        // Animate scrolling to next element if viewport is "md" breakpoint or lower.
        if ($(window).width() < 1024) {
            $('html, body').animate({
                scrollTop: $(this).offset().top
            });
        }

    // }

});
